export default [{
  mainButton: {
    name: 'staff',
    label: 'Сотрудники',
    goTo: '/staff',
    tooltip: 'Всё, что связано с сотрудниками'
  },
  fastButtons: [{
    name: 'staffAdd',
    label: 'добавить сотрудника',
    goTo: '?modal=staff-add'
  }, {
    name: 'staffFilters',
    label: 'фильтр таблицы',
    goTo: '?modal=timatableStaffFilter'
  }]
}, {
  mainButton: {
    name: 'autoscheduling',
    label: 'Авто<br>составление',
    goTo: '?modal=autoscheduling',
    tooltip: 'Автосоставление графиков для сотрудников и настройки'
  },
  fastButtons: [{
    name: 'departments',
    label: 'параметры <%shop_singular_R%>',
    goTo: '?modal=DepSettings~currentDep'
  }]
}, {
  mainButton: {
    name: 'manualChanges',
    label: 'Ручные<br>изменения',
    tooltip: 'Ручные изменения расписания сотрудников',
    menu: [{
      name: 'deleteShifts',
      label: 'Удаление графика',
      goTo: '?modal=delete-schedule',
      metrikaIdReach: 'btn_delete_shifts'
    }, {
      name: 'timetableDuplicateSchedule',
      label: 'Копирование графика',
      goTo: '?modal=duplicate-schedule',
      metrikaIdReach: 'btn_timetable_duplicate_schedule'
    }, {
      name: 'timetableDuplicateScheduleMonth',
      label: 'Копирование из месяца в месяц',
      goTo: '?modal=duplicate-schedule-month',
      metrikaIdReach: 'btn_timetable_duplicate_schedule_month'
    }, {
      name: 'timetableShiftExchange',
      label: 'Обмен сменами',
      goTo: '?modal=timetable-shift-exchange'
    }]
  }
}, {
  mainButton: {
    name: 'coverage',
    label: 'Покрытие',
    tooltip: 'Покрытие!',
    goTo: '?coverage=TOGGLE'
  }
}, {
  mainButton: {
    name: 'tableView',
    label: 'Вид<br>таблицы',
    tooltip: 'Настройки отображения таблицы',
    menu: [{
      name: 'factualApproved',
      label: 'факт подтверждённый',
      goTo: '?tableView=factApproved',
      metrikaIdReach: 'btn_table_view_fact_approved'
    }, {
      name: 'factualTabel',
      label: 'факт/осн/доп табель',
      goTo: '?tableView=factTabel'
    }]
  },
  fastButtons: [{
    name: 'planDraft',
    label: 'план черновик',
    goTo: '?tableView=planBothCompare',
    metrikaIdReach: 'follow_to_plan_bothCompare'
  }, {
    name: 'planApproved',
    label: 'план подтверждённый',
    goTo: '?tableView=planApproved',
    metrikaIdReach: 'follow_to_plan_approved'
  }, {
    name: 'viewPlannedFactual',
    label: 'план. подтв. / факт. подтв.',
    goTo: '?tableView=planFactApprovedCompare',
    metrikaIdReach: 'follow_to_fact_approved'
  }, {
    name: 'factualDraft',
    label: 'факт черновик',
    goTo: '?tableView=factBothCompare',
    metrikaIdReach: 'follow_to_fact_bothCompare'
  }]
}, {
  mainButton: {
    name: 'tableDisplayMonth',
    label: 'Отображения',
    tooltip: 'отображать по месяцу',
    goTo: '?tableDisplay=month'
  },
  fastButtons: [{
    name: 'tableDisplayWeek',
    label: 'отображать по неделе',
    goTo: '?tableDisplay=week',
    metrikaIdReach: 'btn_display_week'
  }, {
    name: 'tableDisplayDay',
    label: 'отображать по дню',
    goTo: '?tableDisplay=day',
    metrikaIdReach: 'btn_display_day'
  }]
}, {
  mainButton: {
    name: 'acceptances',
    label: 'Подтвердить<br>график',
    tooltip: 'Подтвердить изменения в графике',
    allow: 'WorkerDay_approve',
    menu: [{
      name: 'acceptPlanned',
      label: 'плановый',
      goTo: '?modal=accept-plan'
    }, {
      name: 'acceptFactual',
      label: 'фактический',
      goTo: '?modal=accept-fact'
    }, {
      name: 'acceptRequest',
      label: 'отправить запрос',
      goTo: '?modal=accept-request'
    }]
  },
  fastButtons: [{
    name: 'recalсTimesheet',
    label: 'пересчет табеля',
    goTo: '?modal=recalc-timesheet'
  }, {
    name: 'recalcWorkingHours',
    label: 'пересчет рабочих часов',
    goTo: '?modal=recalc-working'
  }]
}, {
  mainButton: {
    name: 'uploadDownload',
    label: 'Загрузка<br>Выгрузка',
    tooltip: 'Загрузка и выгрузка данных',
    menu: [{
      name: 'upload',
      label: 'загрузить график',
      goTo: '?modal=upload-schedule'
    }, {
      name: 'download',
      label: 'скачать "График смен"',
      goTo: '?modal=download-schedule',
      metrikaIdReach: 'btn_download_timetable_schedule'
    }, {
      name: 'download',
      label: 'скачать "Табель"',
      goTo: '?modal=download-tablet',
      metrikaIdReach: 'btn_download_timetable_tablet'
    }, {
      name: 'download',
      label: 'скачать "Потребность в сотрудниках"',
      goTo: '?modal=download-need',
      metrikaIdReach: 'btn_download_timetable_need'
    }, {
      name: 'download',
      label: 'скачать "Консолидированный отчет об отработанном времени"',
      goTo: '?modal=download-consolidated',
      metrikaIdReach: 'btn_download_consolidated_report'
    }, {
      name: 'download',
      label: 'скачать "Отчёт по отметкам сотрудников"',
      goTo: '?modal=download-tick',
      metrikaIdReach: 'btn_download_tick_report'
    }, {
      name: 'download',
      label: 'cкачать "Отчёт по отклонениям от планового графика"',
      goTo: '?modal=download-scheduleDeviation',
      metrikaIdReach: 'btn_download_schedule_deviation'
    }]
  }
}];